var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import moment from 'moment';
import { Helmet } from 'react-helmet';
import * as pageActions from './actions';
import injectReducer from '../../utils/injectReducer';
import reducer from './reducer';
import * as pageSelectors from './selectors';
import ConditionsModal from '../../components/ConditionsModal';
import { P } from '../../components/UI-helpers/typography';
import { Button } from '@appspotr/ui-kit';
import Breadcrumbs from '../../components/OrgBreadcrumbs';
import { PageWrapper, PageHeader, PageContent, PageHeaderTitle, } from '../../components/Page';
import { LatestPolicy, PolicyCircle, DataPrivacyBox, DataPrivacyTitle, PolicyListContent, PolicyListWrapper, ButtonExtraSpacing, LatestPolicyWrapper, DataPrivacySubTitle, DeleteButtonPosition, LatestPolicyIndicator, DataPrivacyContentPara, LatestPolicyDescription, DataPrivacyContentHeader, LatestPolicyDescriptionWrapper, } from './styles';
var DataAndPrivacy = /** @class */ (function (_super) {
    __extends(DataAndPrivacy, _super);
    function DataAndPrivacy() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isVisiblePopUpTnC: false,
            isVisiblePopUpPP: false,
        };
        _this.UIActions = {
            popupTnC: {
                show: function () {
                    _this.setState({ isVisiblePopUpTnC: true });
                },
                hide: function () {
                    _this.setState({ isVisiblePopUpTnC: false });
                },
            },
            popupPP: {
                show: function () {
                    _this.setState({ isVisiblePopUpPP: true });
                },
                hide: function () {
                    _this.setState({ isVisiblePopUpPP: false });
                },
            },
        };
        _this.goToPrivacyList = function () {
            _this.props.navigate('/dataprivacy/privacyList');
            console.log('navigated to privacyList');
        };
        _this.goToRequestData = function () {
            _this.props.navigate('/dataprivacy/requestdata');
        };
        _this.goToDeleteMyAccount = function () {
            _this.props.navigate('/dataprivacy/deleteaccount');
        };
        return _this;
    }
    DataAndPrivacy.prototype.componentDidMount = function () {
        this.props.onLoadLatestPolicy();
        this.props.onLoadLatestTerm();
    };
    DataAndPrivacy.prototype.render = function () {
        var dataAndPrivacy = this.props.dataAndPrivacy;
        var crumbs = [{ to: '', text: 'Data & Privacy' }];
        return (_jsx(_Fragment, { children: _jsxs(PageWrapper, { children: [_jsxs(Helmet, { children: [_jsx("title", { children: "Data and Privacy" }), _jsx("meta", { name: "description", content: "Data and Privacy" })] }), _jsx(PageHeader, { children: _jsx(PageHeaderTitle, { children: _jsx(Breadcrumbs, { crumbs: crumbs }) }) }), _jsx(PageContent, { children: _jsxs(DataPrivacyBox, { children: [dataAndPrivacy.latestTerm && (_jsx(ConditionsModal, { title: dataAndPrivacy.latestTerm.name, description: "Updated on: ".concat(moment(dataAndPrivacy.latestTerm.created_at).format('YYYY-MM-DD')), content: dataAndPrivacy.latestTerm.description, open: this.state.isVisiblePopUpTnC, onOK: this.UIActions.popupTnC.hide, onClose: this.UIActions.popupTnC.hide })), dataAndPrivacy.latestPolicy && (_jsx(ConditionsModal, { title: dataAndPrivacy.latestPolicy.name, description: "Updated on: ".concat(moment(dataAndPrivacy.latestPolicy.created_at).format('YYYY-MM-DD')), content: dataAndPrivacy.latestPolicy.description, open: this.state.isVisiblePopUpPP, onOK: this.UIActions.popupPP.hide, onClose: this.UIActions.popupPP.hide })), _jsxs(DataPrivacyTitle, { children: [_jsx(P, __assign({ black: true, bold: true, fontSize: 36 }, { children: "Data & Privacy" })), _jsx(P, { children: "Access your Data & Privacy Information" })] }), _jsxs(DataPrivacySubTitle, { children: [_jsx(DataPrivacyContentPara, { children: _jsx(P, __assign({ black: true, fontSize: 24 }, { children: "Privacy Policy" })) }), _jsxs(DataPrivacyContentHeader, { children: [dataAndPrivacy.latestPolicy && (_jsxs(LatestPolicyWrapper, { children: [_jsxs(LatestPolicy, { children: [_jsxs(LatestPolicyIndicator, { children: [_jsx(PolicyCircle, {}), _jsx(P, __assign({ fontSize: 20, black: true }, { children: "Privacy Policy" }))] }), _jsx(P, __assign({ black: true }, { children: moment(dataAndPrivacy.latestPolicy.created_at).format('YYYY-MM-DD') }))] }), _jsxs(LatestPolicyDescriptionWrapper, { children: [_jsx(LatestPolicyDescription, { children: dataAndPrivacy.latestPolicy.description }), _jsx(Button, __assign({ type: "primary", onClick: this.UIActions.popupPP.show }, { children: "Read" }))] })] })), dataAndPrivacy.latestPolicy && (_jsxs(PolicyListWrapper, { children: [_jsxs(PolicyListContent, { children: [_jsx(P, __assign({ fontSize: 20, black: true }, { children: "Privacy Policy List" })), _jsx(P, { children: "See the list of previous privacy policies of the platform" })] }), _jsx(ButtonExtraSpacing, { children: _jsx(Button, __assign({ type: "primary", onClick: this.goToPrivacyList }, { children: "View All" })) })] })), _jsxs(PolicyListWrapper, { children: [_jsxs(PolicyListContent, { children: [_jsx(P, __assign({ fontSize: 20, black: true }, { children: "Information & Data" })), _jsx(P, { children: "Get a duplicate of your data" })] }), _jsx(ButtonExtraSpacing, { children: _jsx(Button, __assign({ type: "primary", onClick: this.goToRequestData }, { children: "Request Data" })) })] }), _jsxs(PolicyListWrapper, { children: [_jsxs(PolicyListContent, { children: [_jsx(P, __assign({ fontSize: 20, black: true }, { children: "Terms & Conditions" })), _jsx(P, { children: "Read the terms and conditions" })] }), _jsx(ButtonExtraSpacing, { children: _jsx(Button, __assign({ onClick: this.UIActions.popupTnC.show }, { children: "Read" })) })] }), _jsx(DeleteButtonPosition, { children: _jsx(Button, __assign({ onClick: this.goToDeleteMyAccount, type: "dangerOutline" }, { children: "Delete My Account" })) })] })] })] }) })] }) }));
    };
    return DataAndPrivacy;
}(React.Component));
var mapStateToProps = createStructuredSelector({
    dataAndPrivacy: pageSelectors.makeDataAndPrivacyPageDomain(),
});
var mapDispatchToProps = function (dispatch) { return ({
    onLoadLatestPolicy: function () {
        dispatch(pageActions.loadLatestPolicy());
    },
    onLoadLatestTerm: function () {
        dispatch(pageActions.loadLatestTerm());
    },
}); };
var withConnect = connect(mapStateToProps, mapDispatchToProps);
var withReducer = injectReducer({
    key: 'dataAndPrivacy',
    reducer: reducer,
});
var DataAndPrivacyPageWrapper = function (props) {
    var params = useParams();
    var navigate = useNavigate();
    return (_jsx(ConnectedDataAndPrivacyPage, __assign({ params: params, navigate: navigate }, props)));
};
var ConnectedDataAndPrivacyPage = compose(withConnect, withReducer)(DataAndPrivacy);
export default DataAndPrivacyPageWrapper;
